export const RANGE_PRESETS = ['Last 30 days', 'Last 90 days', 'This month', 'Last month', 'This year'] as const;

export type RangePreset = (typeof RANGE_PRESETS)[number];
